module.exports = __webpack_public_path__ + "/images/document-selected.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/document-selected.svg
// module id = 618
// module chunks = 0